export default __webpack_public_path__ + "static/media/fridge2-beforeA-768w.03808f13.avif";